import { render, staticRenderFns } from "./SerieNumeroFormDevolucionBodega.vue?vue&type=template&id=283fe606&scoped=true&"
import script from "./SerieNumeroFormDevolucionBodega.vue?vue&type=script&lang=ts&"
export * from "./SerieNumeroFormDevolucionBodega.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283fe606",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('283fe606', component.options)
    } else {
      api.reload('283fe606', component.options)
    }
    module.hot.accept("./SerieNumeroFormDevolucionBodega.vue?vue&type=template&id=283fe606&scoped=true&", function () {
      api.rerender('283fe606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ReportesSerieActiva/SerieNumeroFormDevolucionBodega.vue"
export default component.exports